module.exports = __webpack_public_path__ + "static/media/thisamericanlife.a66a0b86.svg";